import React, { useState } from "react"
import { ColorInput } from "core/color-picker"
import Grid from "@kit/design/grid"
import Stack from "@kit/design/stack"
import { Alignment } from "core/alignment"
import { Field } from "core/form"
import { Input } from "core/deprecated-inputs"
import "./index.css"

const isValidUrl = url => {
  const supportedVideoLinkSnippet = /\S*youtube\.com\/\S*\/*watch\S*|youtu\.be/
  return url.match(supportedVideoLinkSnippet)
}

export const VideoMenu = ({ editor, node }) => {
  const video = node
  const [href, setHref] = useState(video.data.get("href") || "")
  const alignment = video.data.get("alignment") || "center"
  const width = video.data.get("width") || 480
  const accentColor = video.data.get("accentColor") || "#1677BE"
  const playButtonColor = video.data.get("playButtonColor") || "#FFFFFF"

  const setVideoData = event => {
    const { name, value } = event.target
    editor.command("setNodeByKey", video.key, {
      data: { ...video.data.toJS(), [name]: value }
    })
  }

  const setAlignment = ({ name, value }) => {
    setVideoData({ target: { name, value } })
  }

  const updateHref = event => {
    const { name, value } = event.target
    setHref(value)

    if (isValidUrl(value)) {
      editor.command("setNodeByKey", video.key, {
        data: { ...video.data.toJS(), [name]: value }
      })
    }
  }

  const onKeyDown = event => {
    if (event.key === "Enter") event.preventDefault()
  }

  return (
    <Stack className="p-4" spacing={3}>
      <Field
        control={Input}
        label="YouTube video URL"
        name="href"
        value={href}
        onChange={updateHref}
        onKeyDown={onKeyDown}
        controlClassName="ck-input"
      >
        {!isValidUrl(href) && (
          <p style={{ fontSize: "0.75em" }}>This URL is not a YouTube link</p>
        )}
      </Field>
      <Grid columns="repeat(2, 120px)" gap=".5rem" rowGap=".75rem">
        <Field
          control={ColorInput}
          label="Accent color"
          name="accentColor"
          onChange={setVideoData}
          value={accentColor}
        />
        <Field
          control={ColorInput}
          label="Play button color"
          name="playButtonColor"
          onChange={setVideoData}
          value={playButtonColor}
        />
        <Field
          control={Input}
          label="Video size"
          type="number"
          name="width"
          min={100}
          max={480}
          value={width}
          onChange={setVideoData}
        />
        <Stack spacing={2}>
          <div className="inline-block text-sm font-semibold leading-snug text-gray-700">
            Alignment
          </div>
          <Alignment
            alignment={alignment}
            onChange={({ name, value }) => setAlignment({ name, value })}
          />
        </Stack>
      </Grid>
      <p className="text-gray-700 text-xs italic" style={{ maxWidth: "240px" }}>
        Want to embed the video inline?
        <br />
        Click the + icon and select &apos;Video&apos;.
      </p>
    </Stack>
  )
}
